import styled from 'styled-components'

import { InputLabel, TextField } from '@material-ui/core'

export interface InputProps {
  width?: string
  marginRight?: string
}

export const Container = styled.div``

export const ContainerForm = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: 35px 0px 0 0px;
  height: calc(100% - 19vh);
`
export const FormLineInput = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
`
export const ContainerInput = styled.div<InputProps>`
  width: ${props => props.width};
  margin-right: ${props => props.marginRight};
`
export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 25px 0px;
  gap: 1rem;
`
export const SelectContainer = styled.div`
  width: 775px;
  margin-bottom: 23px;
`
export const MuiInput = styled(TextField)`
  width: 100%;
  padding-right: 1rem;
  border-radius: 0.25rem;

  input {
    padding: 18.5px 14px;
  }

  fieldset {
    border-color: rgba(0, 0, 0, 0.23) !important;
  }
`
export const CustomInputLabel = styled(InputLabel)``
